import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const RatesCountriesLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-RatesCountries' */ './RatesCountries'),
  {
    fallback: <LoadingComponent />,
  }
);

export default RatesCountriesLoadable;
